module.exports = __webpack_public_path__ + "static/media/live15_03_2018.6a73f68b.jpg";